<template>
  <div class="layout-container">
    <h1>Agent Directory</h1>
  </div>
</template>
